const ProductDetailComplementaryProduct = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_TitleSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'titleSettings',
        },
        options: {
          textSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          textColor: {
            type: 'HexColor',
            order: 2,
          },
          textStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          textWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
      Menu_ProductSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'productSettings',
        },
        options: {
          ProductTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          ProductTextColor: {
            type: 'HexColor',
            order: 2,
          },
          ProductTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          ProductTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          discountTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
          discountTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 6,
          },
          discountTextColor: {
            type: 'HexColor',
            order: 6,
          },
          discountTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 7,
          },
          discountTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 8,
          },
          discountBackgroundColor: {
            type: 'HexColor',
            order: 9,
          },
          discountBorderRadius: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 10,
          },
          oldPriceTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 11,
          },
          oldPriceTextColor: {
            type: 'HexColor',
            order: 12,
          },
          oldPriceTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          newPriceTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 13,
          },
          newPriceTextColor: {
            type: 'HexColor',
            order: 14,
          },
          newPriceTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 15,
          },
        },
      },
      Menu_InformationAreaSettings: {
        type: 'Menu',
        order: 300,
        renderOptions: {
          controlKey: 'informationAreaSettings',
        },
        options: {
          informationText: {
            type: 'Text',
            order: 1,
          },
          informationTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          informationTextColor: {
            type: 'HexColor',
            order: 2,
          },
          informationTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          informationTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
        },
      },
      Menu_PriceSettings: {
        type: 'Menu',
        order: 400,
        renderOptions: {
          controlKey: 'priceSettings',
        },
        options: {
          priceText: {
            type: 'Text',
            order: 1,
          },
          advantageousPriceText: {
            type: 'Text',
            order: 1,
          },
          priceTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 2,
          },
          priceTextColor: {
            type: 'HexColor',
            order: 2,
          },
          priceTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 3,
          },
          priceTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 4,
          },
          priceSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 5,
          },
          priceColor: {
            type: 'HexColor',
            order: 6,
          },
          priceStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 7,
          },
          priceWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 8,
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 500,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              borderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          borderColor: {
            type: 'HexColor',
            order: 2,
          },
          gap: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 3,
          },
          backgroundColor: {
            type: 'HexColor',
            order: 4,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'ComplementaryProduct_1',
      name: 'ComplementaryProduct_1',
      type: 'ProductDetailComplementaryProduct',
      data: {},
      customization: {
        textSize: '10px',
        textColor: '#8A8A8A',
        textStyle: 'normal',
        textWeight: '400',
        ProductTextSize: '12px',
        ProductTextColor: '#585C5D',
        ProductTextStyle: 'normal',
        ProductTextWeight: '400',
        discountTextSize: '10px',
        discountTextColor: '#FFFFFF',
        discountTextStyle: 'normal',
        discountTextWeight: '400',
        discountBackgroundColor: '#000000',
        discountBorderRadius: '0px 0px 0px 0px',
        oldPriceTextSize: '14px',
        oldPriceTextColor: '#B2B0B6',
        oldPriceTextWeight: '400',
        newPriceTextSize: '14px',
        newPriceTextColor: '#000000',
        newPriceTextWeight: '400',
        informationText: 'İncelediğiniz ürünle birlikte bu ürün(ler) de sepetinize eklenecektir!',
        informationTextSize: '10px',
        informationTextColor: '#000000',
        informationTextStyle: 'normal',
        informationTextWeight: '400',
        priceText: 'Toplam',
        priceTextSize: '12px',
        priceTextColor: '#000000',
        priceTextStyle: 'normal',
        priceTextWeight: '400',
        priceSize: '12px',
        priceColor: '#000000',
        priceStyle: 'normal',
        priceWeight: '400',
        containerPadding: '10px 10px 10px 10px',
        padding: '10px 10px 10px 10px',
        gap: '10px',
        backgroundColor: '#FFFFFF',
        advantageousPriceText: 'Avantajlı Toplam Fiyat',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Image_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default ProductDetailComplementaryProduct;
